export default __webpack_public_path__ + "static/media/Howler.caf28c37.jpg";